import { defineQuery, removeEntity } from "bitecs";
import { DestroyAtExtremeDistance } from "../bit-components";
import { removeNetworkedObject } from "../utils/removeNetworkedObject";

const DIST = 1000;
const pos = new THREE.Vector3();
const entitiesDeleted = [];

const query = defineQuery([DestroyAtExtremeDistance]);
export function destroyAtExtremeDistanceSystem(world) {
  const ents = query(world);
  if (!ents.length) return;

  // Check only one per frame
  const eid = ents[world.time.tick % ents.length];
  const obj = world.eid2obj.get(eid);
  obj.getWorldPosition(pos);
  if (pos.x < -DIST || pos.x > DIST || pos.y < -DIST || pos.y > DIST || pos.z < -DIST || pos.z > DIST) {
    if (entitiesDeleted.includes(eid)) return;
    entitiesDeleted.push(eid);
    const sceneEl = document.querySelector("a-scene");

    if (sceneEl.is("frozen") && sceneEl.components["freeze-controller"]) {
      sceneEl.components["freeze-controller"].onToggle();
    }
    removeNetworkedObject(sceneEl, obj.el);
  }
}
